import { HStack, Text } from '@chakra-ui/react';
import { ReactElement } from 'react';
import { RelevantYearName, AgeGroup } from '@novaheal/types';
import { getYearCollectionString } from 'utils/getYearCollectionString';
import { EducationIcon, TimeIcon } from 'assets/icons/v2';
import { VSeparator } from 'components/common/VSeparator';
import { ReadBadge } from 'components/common/ArticleEntry/ReadBadge';
import AgeGroupIcons from './AgeGroupIcons';

type InformationBarProps = {
  readingTime: number;
  relevantYears: RelevantYearName[];
  ageGroups: AgeGroup[];
  isRead?: boolean | null;
};

const InformationBar = ({
  readingTime,
  relevantYears,
  ageGroups,
  isRead = false,
}: InformationBarProps): ReactElement => {
  const readingTimeText = `${readingTime} min`;
  const relevantYearsText = getYearCollectionString(relevantYears, 'Jahr');

  return (
    <HStack>
      {!isRead ? (
        <>
          <TimeIcon color="icon.quaternary" boxSize="16px" />
          <Text textStyle="body.s.regular" color="text.tertiary">
            {readingTimeText}
          </Text>
        </>
      ) : (
        <ReadBadge />
      )}

      <VSeparator textStyle="body.s.regular" color="text.tertiary" />
      <EducationIcon color="icon.quaternary" boxSize="16px" />
      <Text textStyle="body.s.regular" color="text.tertiary">
        {relevantYearsText}
      </Text>
      <VSeparator textStyle="body.s.regular" color="text.tertiary" />
      <AgeGroupIcons ageGroups={ageGroups} />
    </HStack>
  );
};

export default InformationBar;
